import get from 'lodash-es/get'
import { connect } from 'react-redux'

import { setActiveAudio } from '../../../../../common/actions/searchPage'
import { IRootState } from '../../../../../common/reducers'
import { IItem } from '../../../../../typings/searchResults'
import AudioPlayer from './audioPlayer'

interface IStateProps {
  isActive: boolean
  searchAudioVolumeLevel: number
  searchAudioMuted: boolean
}

interface IDispatchProps {
  onPlay: () => void
}

interface IOwnProps {
  item: IItem
  viewType: string
}

const mapStateToProps = (
  state: IRootState,
  ownProps: IOwnProps
): IStateProps => {
  const itemAudioSrc = get(
    ownProps,
    'item.previews.icon_with_audio_preview.mp3_url'
  )
  const {
    searchPage: { activeAudio },
    user: {
      preferences: { searchAudioVolumeLevel, searchAudioMuted }
    }
  } = state
  return {
    isActive: itemAudioSrc && itemAudioSrc === activeAudio,
    searchAudioVolumeLevel,
    searchAudioMuted
  }
}

const mapDispatchToProps = (
  dispatch: any,
  ownProps: IOwnProps
): IDispatchProps => {
  const itemAudioSrc = get(
    ownProps,
    'item.previews.icon_with_audio_preview.mp3_url'
  )
  return {
    onPlay: () => dispatch(setActiveAudio(itemAudioSrc))
  }
}

const AudioPlayerContainer = connect<IStateProps, IDispatchProps, IOwnProps>(
  mapStateToProps,
  mapDispatchToProps
)(AudioPlayer)

export default AudioPlayerContainer
